@if (questions != null) {
  <div>
    @if (form) {
      <form (ngSubmit)="onSubmit()" [formGroup]="form" >
        @for (question of questions; track question) {
          <div class="form-row">
            <app-assessment-question [question]="question" [form]="form" (change)="onValueChanged($event)"></app-assessment-question>
          </div>
        }
        <div class="form-row">
          <button type="submit" [disabled]="!form.valid" class="aside-fixed-button primary-btn submitButton"> Submit <i _ngcontent-jmg-c117="" aria-hidden="true" class="fa fa-check ml-2 ng-star-inserted"></i></button>
          <!-- <button type="submit" [disabled]="!form.valid">Save</button> -->
        </div>
      </form>
    }
    @if (payLoad) {
      <div class="form-row">
        <strong>Saved the following values</strong><br>{{payLoad}}
      </div>
    }
  </div>
}